import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';

@Directive({
  standalone:true,
  selector: '[appGlobalUpload]'
})
export class GlobalUploadDirective implements OnInit{
  universalService:any;
  directiveService:any;
  listService:any;
  amount: any = '';
  isAnimating: boolean = false;


  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {  
    if(this.el.nativeElement.getAttribute('global-droppable')== 'false' || (this.universalService.chromeOS && !this.universalService.dragDropWithinApp))return
    if (event.preventDefault) event.preventDefault();
    if(!this.universalService.folderSpecificDrag && this.universalService.allowUpload){
      this.dragOver(event)
    }
  };

  @HostListener('dragleave', ['$event']) dragLeaveEvent(event) {
    if(this.el.nativeElement.getAttribute('global-droppable')== 'false' || this.universalService.chromeOS && !this.universalService.dragDropWithinApp)return
    if (event.preventDefault) event.preventDefault();
    if(!this.universalService.folderSpecificDrag && this.universalService.allowUpload){
      this.dragLeave(event)
    }
  };

  @HostListener('drop', ['$event']) dropEvent(event){
    if(this.el.nativeElement.getAttribute('global-droppable')== 'false' || this.universalService.chromeOS && !this.universalService.dragDropWithinApp)return
    if (event.preventDefault) event.preventDefault();
    if(!this.universalService.folderSpecificDrag && this.universalService.allowUpload){
      this.onDrop(event)
    }
  }
  constructor(private el: ElementRef,private globalService:GlobalService) { 
    this.setEnvObjects(this.globalService);
  }
  ngOnInit(){
    
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.directiveService = globalService.getDirectiveServiceRef();
  }

  dragOver(event) {
    if (event.preventDefault) event.preventDefault(); 
    if(this.universalService.allowUpload){
      if(event.pageY/window.innerHeight > 0.8 && !this.isAnimating){
        this.amount = '+=30';
        this.isAnimating = true;
        this.scroll();
      }
      var bannerHeight = $('.pseudo-banner-container').outerHeight(true) ? $('.pseudo-banner-container').outerHeight(true) : 0;
      if((event.pageY - bannerHeight)/(window.innerHeight) < 0.2 && !this.isAnimating){
        this.amount = '-=30';
        this.isAnimating = true;
        this.scroll();
      } 
      this.addOverlay()
    }
  }

  dragLeave(event){
    var self = this;
    if (event.preventDefault) event.preventDefault();
    setTimeout(() => {
      self.removeOverlay();
    }, 800);
  }

  async onDrop(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
    if(this.universalService.dragDropWithinApp){
      $('.ag-row').removeClass('disable-row');
      $(".gridItem").removeClass("disable-row");
      $(".fileThumbnail").removeClass("disable-row");
      this.universalService.dragDropWithinApp = false;
      var checkBoxChecked = document.querySelectorAll('.grid_info');
      if(checkBoxChecked.length == 0){ 
          this.listService.deSelectAll(null)
      }
      return;
    }
    setTimeout(() => {
      this.removeOverlay();
    }, 800);
  }

  addOverlay(){
    if(this.universalService.dragDropWithinApp){
      return;
    }
      $('.tab-wrapper').addClass('drag-highlight');
      $('.drag-n-drop-wrap').show();
  }

  removeOverlay(){
      $('.tab-wrapper').removeClass('drag-highlight');
      $('.drag-n-drop-wrap').hide();
  }

  scroll() {
    var self = this;
      $('.allFilesScrollableContainer').animate({
          scrollTop: this.amount
      }, 100, 'linear',function() {
          if (self.amount != '') {
            self.amount = '';
            self.isAnimating = false;
            //self.scroll();
          }
      });
  }

}

